import { Injectable, OnDestroy } from '@angular/core';
import { HttpService } from './http.service';
import { SmBaseService } from './sm-base.service';
import { Observable, Subscription } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { AuthService } from '..';

@Injectable()
export class AutocompleteService extends SmBaseService implements OnDestroy {
	private _cache: { [key: string]: Observable<any> } = {};
	private _subscription: Subscription;

	constructor(http: HttpService,
		private _authService: AuthService
	) {
		super(http, 'autocomplete');

		this._subscription = this._authService.onTokenChanged.subscribe((token) => {
			this.clearCache();
		});
	}

	ngOnDestroy() {
		this._subscription.unsubscribe();
	}

	clearCache() {
		this._cache = {};
	}

	clearSingleCache(code: string) {
		this._cache[code] = null;
	}

	get(dataSource: string, options?: AutocompleteOptions) {
		let params: { [key: string]: string } = {};
		let cache: boolean = true;

		if (options != null) {
			if (options.parameters != null) {
				Object.assign(params, options.parameters);
			}

			params['pattern'] = options.pattern || '';
			if (options.maxResults) {
				params['maxresults'] = '' + options.maxResults;
			}
			if (options.minPatternLength) {
				params['minpatternlength'] = '' + options.minPatternLength;
			}
			if (options.cache != null) {
				cache = options.cache;
			}
		}

		let code = dataSource;
		if (this._cache[code] == null || cache == false) {
			this._cache[code] = this._getAs<AutocompleteValueModel[]>(encodeURIComponent(dataSource), { search: params })
				.pipe(publishReplay(1))
				.pipe(refCount());
		}

		return this._cache[code];
	}
}

export interface AutocompleteOptions {
	pattern?: string;
	maxResults?: number;
	minPatternLength?: string;
	parameters?: { [key: string]: string };
	cache?: boolean;
}

export interface ValueModel {
	value: number | string;
	name: string;
}

export interface AutocompleteValueModel extends ValueModel {
	isDisabled: boolean;
	group: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/autocomplete.service.ts